<template id="processingOrderListModal">
<!--div class="modal fade overlap in" id="p_orderslistModal" tabindex="-1" role="dialog" aria-labelledby="p_orderslistModalLabel" style="display: none;"-->
<div class="modal fade overlap in" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!--img class="img-responsive" src="images/popthumb2.png" alt=""-->
          <div class="icon">
            <!-- Icon Loading -->
            <i class="fa fa-plus"></i>
            <!-- Icon Done -->
            <!--i class="fa fa-check fa-fw"></i-->
          </div>
          <h4 class="modal-title" id="p_orderslistModalLabel">{{res.processing_orders}}</h4>
        </div>
        <div class="modal-body">
          <p>{{res.processing_orders_desc}}</p>
          <div class="p_orderslist_wrapper">
            <div class="list-group tabbable" id="p_orderslist" role="tablist">
              <a style="cursor:pointer" v-on:click="amendOrder(order)" v-for="(order) in orders" v-bind:key="order.invid" class="list-group-item list-group-item-action" data-toggle="list" role="tab">
                <span class="number">{{order.invcode}}</span>
                <span class="price">{{curr}} {{order.paidamt | format(fmt)}}</span>
              </a>
            </div>
          </div>
          <div class="centerbutton">
            <input class="redButon" :value="res.cancel" type="submit" v-on:click="cancelAction()">
            <input class="redButon" :value="res.neworder" type="submit" v-on:click="amendOrder(null)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import utils from './Utils.vue'
import modalBox from './ModalBox.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  extends: modalBox,
  name: 'processingOrderListModal',
  props:['fmt', 'common_res', 'res'],
  data () {
    return {
      curr:null,
      nextfunc:null,
      orders:[]
    }
  },
  created:function() {
    this.curr = utils.getCurrencySym();
  },
  mounted:function() {
    var self = this;
    self.$root.$on('confirm_processing', data => {
      self.show();
      self.orders.splice(0, self.orders.length);
      for (var i=0;i<data.list.length;i++) {
        self.orders.push(data.list[i]);
        //console.log("push", data.list[i]);
      }
      self.nextfunc = data.nextfunc;
    });
  },
  methods: {
    cancelAction:function() {
      this.nextfunc = null;
      this.close();
    },
    amendOrder:function(order) {
      if (this.nextfunc != null) {
        if (order != null) {
          this.nextfunc(order.invcode);
        } else {
          this.nextfunc(null);
        }
      }
      this.cancelAction();
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ProcessingOrderListModal.vue